<template>
    <div class="login">

        <Loader v-if="isLoading"/>
        <div class="box">
            <div class="content">
                <b-form class="form-vertical login-form formV2" autocomplete="off">
                    <div class="text-center">
                        <img class="mb-4" src="img/logo-login.png" alt="logo go fix">
                    </div>
                    <div class="alert fade in alert-danger" style="display: none;"> <i class="icon-remove close" data-dismiss="alert"></i> Enter any username and password. </div>
                    <gofix-form-input class="mb-3" label="Email" @enter="onEnterClick" v-model="$v.user.email.$model" desc="e.g. user@gmail.com" type="email" required></gofix-form-input>
                    <div class="pb-4"></div>
                    <gofix-form-input label="Password" @enter="onEnterClick" autocomplete="current-password" v-model="$v.user.password.$model" :type="type" required>
                        <template #gofixInput:text:after-desc>
                            <i v-if="type!='text'" @click="showPassword" class="fa fa-eye activePassword"></i>
                            <i v-if="type=='text'" @click="showPassword" class="fa fa-eye-slash activePassword" :class="{ 'active': type=='text'  }" ></i>
                        </template>
                    </gofix-form-input>
                    <gofix-form-dropdown
                            label="Select Application"
                            v-model="user.platform"
                            :options="platforms"
                            vLabel="reference_value_text"
                            :filterable="false">
                    </gofix-form-dropdown>
                    <div class="form-actions">
                        <router-link class="c-orange forgotPass" :to="``">Forgot Password?</router-link>
                        <b-button type="button" @click="login" variant="primary" :disabled="isAction" class="submit btn pull-right"> Login  <b-spinner v-if="isAction"  small></b-spinner>  </b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { required, minLength,email } from 'vuelidate/lib/validators'
    import { floatLabel } from '@/_floatLableClass.js'
    import Loader from './Loader.vue';
    const AUTOFILLED = 'is-autofilled'
    const onAutoFillStart = (el) => el.classList.add('e-input-focus')
    const onAutoFillCancel = (el) => el.classList.remove('e-input-focus')
    const onAnimationStart = ({ target, animationName }) => {
        switch (animationName) {
            case 'onAutoFillStart':
                return onAutoFillStart(target)
            case 'onAutoFillCancel':
                return onAutoFillCancel(target)
        }
    };

    export default {
        name: 'UniLogIn',
        components: {
            Loader
        },
        data () {
            return {
                user : {
                    email : '',
                    password : '',
                    platform: null
                },
                platforms:[],
                isAction : false,
                type : 'password',
                isLoading: false,
            }
        },
        mixins: [validationMixin],
        validations: {
            user: {
                email: {
                    required,
                    email,
                },
                password : {
                    required
                }
            }
        },
        computed: {

        },
        watch: {

        },
        async created() {
            this.getPlatforms();
        },
        mounted: async function() {
            document.querySelector('.form-control').addEventListener('animationstart', onAnimationStart, false)
            floatLabel();
        },
        updated: async function() {
            await this.$nextTick();
            await floatLabel()
            await this.setClassInput();
        },
        methods:{
            async login(){
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return false;
                }
                this.isLoading = true
                this.isAction = true;
                this.$store.dispatch( 'AuthController/login', {
                    email : this.user.email.trim(),
                    password : this.user.password.trim() ,
                    platform : this.user.platform ? this.user.platform.reference_value_abbr : null
                })
                    .then(async result =>{
                        this.isAction = false;
                        if(!this.user.platform){
                            this.$router.push(`/platform`);
                        }else{
                            await this.$store.dispatch("AuthController/getRoles");
                            window.location.replace(this.user.platform.reference_value_link);
                        }
                        this.isLoading = false
                    })
                    .catch(error=>{
                        console.log(error)
                        this.isAction = false;
                        setTimeout(() => {
                            this.isLoading = false
                        },1000)
                        this.$bvToast.toast('Login error!', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    })
            },
            showPassword(){
                if(this.type == 'password')
                    return this.type = 'text'
                return this.type = 'password'
            },
            onEnterClick: function() {
                this.login();
            },
            async setClassInput() {
                if(!this.user.email) {
                    onAutoFillCancel(document.getElementById('form-group-email'))
                }
                if(!this.user.password) {
                    onAutoFillCancel(document.getElementById('form-group-password'))
                }
            },
            getPlatforms(){
                let filter = {reference_type: "Source Application"};
                let params = {
                    filter: filter,
                    limit: -1
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.platforms = response.items;
                    })
            }
        }
    }
</script>
